import { synopsisParagraphs, themeList } from "@/mocks/nanny";

export default function Synopsis() {
  return (
    <section id="synopsis" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
            <div>
              <span className="text-primary-600 font-label text-sm tracking-[0.2em] uppercase">Story</span>
              <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">作品简介</h2>
            </div>
            <p className="text-foreground-600 text-sm md:text-base max-w-md leading-relaxed">
              一次关于「照顾」与「被照顾」的缓慢叙事，从一间屋子讲到一个家庭。
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
            <div className="lg:col-span-7 space-y-5">
              {synopsisParagraphs.map((p, i) => (
                <p key={i} className="text-foreground-700 text-base md:text-lg leading-loose">
                  {p}
                </p>
              ))}
              <div className="flex flex-wrap gap-2 pt-2">
                {["家庭", "治愈", "生活流", "群像", "成长"].map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="bg-background-100 border border-background-200 rounded-lg overflow-hidden">
                <div className="w-full h-52 md:h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20quiet%20sunlit%20apartment%20hallway%20with%20a%20folded%20linen%20basket%20and%20a%20cat%20resting%20by%20the%20window%2C%20soft%20golden%20afternoon%20light%2C%20muted%20cream%20and%20terracotta%20palette%2C%20art-house%20cinematography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=900&height=700&seq=nanny-synopsis-01&orientation=landscape"
                    alt="《漂亮的保姆》家中走廊的暖调剧照"
                    title="漂亮的保姆 作品氛围 剧照"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <dl className="divide-y divide-background-200">
                  {[
                    ["主要题材", "家庭 / 治愈 / 生活流"],
                    ["故事核心", "被需要与被理解"],
                    ["叙事基调", "温和克制，重细节"],
                    ["推荐场景", "睡前、通勤、周末下午"],
                  ].map(([k, v]) => (
                    <div key={k} className="flex items-center justify-between px-4 md:px-5 py-3">
                      <dt className="text-foreground-500 text-sm">{k}</dt>
                      <dd className="text-foreground-900 text-sm md:text-base font-medium text-right">{v}</dd>
                    </div>
                  ))}
                </dl>
              </div>
            </div>
          </div>

          <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {themeList.map((t) => (
              <div
                key={t.title}
                className="bg-background-100 border border-background-200 rounded-lg p-5 md:p-6 hover:border-accent-300 transition-colors"
              >
                <span className="w-11 h-11 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className={`${t.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{t.title}</h3>
                <p className="mt-2 text-foreground-600 text-sm leading-relaxed">{t.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}